<template>
  <section>
    <v-container class="text-center">
      <v-divider class="mb-1"></v-divider>
      <v-divider class="mb-10"></v-divider>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black red--text custom-font"
      >
        SERVICES
      </span>
      <v-responsive class="mx-auto mb-12" width="56"> </v-responsive>

      <v-row>
        <v-col
          v-for="({ src, text, title, page }, i) in service_list"
          :key="i"
          cols="12"
          md="4"
        >
          <v-img
            :src="getImage(src)"
            class="mb-4"
            height="275"
            max-width="100%"
          ></v-img>

          <v-btn
            @click="navigateRoute(page, 'top')"
            color="black"
            class="font-weight-black mb-4 text-uppercase"
            outlined
          >
            <template v-if="page === 'services_construction'">
              <img
                src="@/assets/ems_images/werek_construction.png"
                class="icon-image mr-2 mb-2"
                alt="Construction"
              />
            </template>
            <h3>{{ title }}</h3>
          </v-btn>

          <!-- 
          <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3> -->

          <div class="title font-weight-light mb-5" v-text="text"></div>
          <v-btn
            @click="navigateRoute(page, 'top')"
            color="red"
            dark
            class="ml-n4 font-weight-black"
            >Learn More</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <div class="py-12"></div>
  </section>
</template>

<script>
export default {
  name: "services",
  components: {},
  data() {
    return {
      service_list: [
        {
          src: "building_services.webp",
          title: "Building Maintenance",
          text: "Our Maintenance Services deliver an all-encompassing approach to building upkeep. From relief superintendents to expert cleaners, we ensure prompt, efficient care for your facilities. Our responsive team is equipped to meet urgent demands, guaranteeing that your property is consistently in pristine condition.",
          page: "services_maintenance",
        },
        {
          src: "distaster.webp",
          title: "Disaster Relief",
          text: "Available 24/7, our Disaster Relief team is ready to tackle urgent mould and asbestos issues, conduct advanced air testing, and manage flood crises. We excel in fire damage repair, employing advanced air scrubbing and providing emergency board-ups. Our thorough approach extends to trauma scene cleanups and a comprehensive equipment rental service for effective disaster response.",
          page: "services_disaster_relief",
        },
        {
          src: "construction.webp",
          title: "Werek Construction",
          text: "Werek Construction provides a comprehensive array of construction services, encompassing everything from general contracting to precise execution of renovations and new builds. Our expertise includes drywall, tiling, bathroom upgrades, painting, stucco, flooring, and roofing, all performed with an unwavering commitment to superior craftsmanship and client satisfaction.",
          page: "services_construction",
        },
      ],
    };
  },
  methods: {
    getImage(imageName) {
      // Construct the require statement with the dynamic path
      return require(`@/assets/ems_images/${imageName}`);
    },
    navigate(page) {
      this.$router.push({ path: page }).catch((err) => {
        if (err.name != "Error") {
          console.error(err);
        }
      });
    },
    navigateRoute(route, section) {
      if (this.$route.path === route) {
        this.$vuetify.goTo("#" + section);
      } else {
        this.$router.push(route).then(() => {
          this.$nextTick(() => {
            // Wait for the next DOM update cycle
            this.$vuetify.goTo("#" + section);
          });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.icon-image {
  width: 24px; /* or any other size */
  height: 24px;
}
</style>